const login = {
  "account": "账号",
  "password": "密码",
  "rememberAccount": "记住账号",
  "accountTip": "请输入您的账号!",
  "smsLogin": "短信登录",
  "accountLogin": "账号登录",
  "passwordTip": "请输入您的密码!",
  "verifyCode": "验证码",
  "verifyCodeTip": "请输入验证码!",
  "verifyCodeLengthTip": "验证码长度为4!",
  "phoneNumber": "手机号码",
  "login": "登录",
  "smsVerifyCode": "短信验证码",
  "sendSms": "发送短信",
  "loginSuccess": "登录成功",
  "welcome": "欢迎您!",
  "phoneNumberFormatError": "手机号码格式错误!",
  "verifyCodeLengthError": "验证码长度不正确!",
  "verifyCodeIsNull": "请输入验证码!",
  "sendAgain": "秒后可再次发送",
  "intelligentPositionSystem":"全场景位置服务系统",
  "usernameOrPasswordError":"用户名或密码错误",
  "beian":"京ICP备16017149号-1",
}
export default login